var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoveBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5.00001H3.081L5.781 1.62501C6.126 1.19301 6.056 0.564013 5.625 0.219013C5.194 -0.124987 4.564 -0.0569866 4.219 0.375013L0.219 5.37501C-0.073 5.74101 -0.073 6.25901 0.219 6.62501L4.219 11.625C4.417 11.872 4.707 12 5 12C5.22 12 5.44 11.928 5.625 11.781C6.056 11.436 6.126 10.807 5.781 10.375L3.081 7.00001H12C12.551 7.00001 13 7.44901 13 8.00001V13C13 13.552 13.448 14 14 14C14.552 14 15 13.552 15 13V8.00001C15 6.34601 13.654 5.00001 12 5.00001Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveBack);
export default __webpack_public_path__ + "static/media/move-back.109c43a12443e7f18c386a84d08e7a58.svg";
export { ForwardRef as ReactComponent };